<template>
    <g clip-path="url(#clip2)">
        <path d="M2.54604 9.12861L9.06315 15.3803L19.4595 5.67436" stroke="white"
              stroke-width="2"></path>
    </g>
    <defs>
        <clipPath id="clip2">
            <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"></rect>
        </clipPath>
    </defs>
</template>

<script>
    export default {
        name: 'icon-check'
    }
</script>